/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import { getSettings } from "../../../services/settings"
import { getImageUrl } from "../../../services/listings"

const About = () => {
    const [photoSrc, setPhotoSrc] = useState("/kaden.webp")

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const settings = await getSettings()
                if (settings.profilePhoto) {
                    setPhotoSrc(getImageUrl(settings.profilePhoto))
                }
            } catch (error) {
                // Fall back to static photo
            }
        }
        fetchSettings()
    }, [])

    return (
        <Box
            sx={{
                padding: { xs: 4, md: 8, lg: 12 }, // Padding for responsiveness (2 units on small, 4 units on larger screens)
                maxWidth: "1200px", // Maximum width for layout
                minHeight: "80vh",
                margin: "0 auto", // Centering the content
            }}
        >
            {/* Top Section with Profile Info and About Text */}
            <Grid container spacing={4} alignItems="center" marginBottom={4}>
                {/* Profile Image Section */}
                <Grid item xs={12} md={4}>
                    <Box
                        component="img"
                        src={photoSrc}
                        alt="Kaden Cowles"
                        sx={{
                            borderRadius: 2,
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                        }}
                    />
                </Grid>

                {/* About Text Section */}
                <Grid item xs={12} md={8}>
                    <Typography
                        variant="overline"
                        sx={{ color: "secondary.main", fontWeight: "bold" }}
                        gutterBottom
                    >
                        ABOUT
                    </Typography>
                    <Typography variant="h4" fontWeight={600} gutterBottom>
                        Kaden Cowles
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        color="textSecondary"
                        gutterBottom
                    >
                        DRE #02116097
                    </Typography>
                    <Typography variant="body1" color="textSecondary" paragraph>
                        Kaden has a background of more than 5 years of
                        residential real estate and property management. Kaden
                        built and developed his own short-term rental management
                        company and utilized his knowledge of the rental world
                        to develop a unique leasing program on The Beer Home
                        Team, assuring clients in all walks of real estate can
                        be assisted.
                    </Typography>
                    <Typography variant="body1" color="textSecondary" paragraph>
                        Kaden has a background of more than 5 years of
                        residential real estate and property management. Kaden
                        built and developed his own short-term rental management
                        company and utilized his knowledge of the rental world
                        to develop a unique leasing program on The Beer Home
                        Team, assuring clients in all walks of real estate can
                        be assisted.
                    </Typography>
                </Grid>
            </Grid>

            {/* Contact Information Section */}
            <Box
                sx={{
                    borderTop: "1px solid #e0e0e0",
                    paddingTop: 2,
                    marginTop: 2,
                }}
            >
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="body2" fontWeight={600}>
                            Phone
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            (619) 330-0797
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="body2" fontWeight={600}>
                            Email
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            contact@krispllc.com
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="body2" fontWeight={600}>
                            Address
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            15932 Bernardo Center Dr, San Diego, CA, 92127
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default About
